import {
  Configuration,
  ReportsApi,
  ReportTemplatesApi,
} from "@socotec.io/report-generator-sdk";
import { useOidcStore } from "vue3-oidc";
import { unauthorizedRetryMiddleware } from "@/setup/clients/unauthorizedRetry";
import { offlineModeMiddleware } from "@/setup/clients/offlineMode";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_U_REPORT_BACK_URL,
  accessToken: () => useOidcStore().state.value.token,
  middleware: [offlineModeMiddleware, unauthorizedRetryMiddleware],
});

export const reportsApi = new ReportsApi(configuration);
export const reportTemplatesApi = new ReportTemplatesApi(configuration);

// Équivalent du listAll gRPC : agrège toutes les pages d'un list SDK.
// Garde-fou : borne dure pour ne jamais boucler sur un `next` qui ne se
// vide pas (5000 éléments à pageSize=100, très au-delà du réel).
const MAX_PAGES = 50;

export const listAllPages = async (listPage) => {
  const results = [];
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const response = await listPage(page);
    results.push(...(response.results ?? []));
    if (!response.next) return results;
  }
  console.error(
    `listAllPages: pagination interrompue après ${MAX_PAGES} pages`
  );
  return results;
};
